export const ORDER_EVENT = "order_event";
export const POSITION_UPDATE = "position_update";
export const BALANCE_UPDATE = "balance_update";
export const ASSET_MARGIN_REPORT = "asset_margin_report";
export const POSITION_MARGIN_REPORT = "position_margin_report";
export const TRADE_EVENT = "trade_event";
export const TRANSFER_EVENT = "transfer_event";